var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"src":_vm.qzUrl,"width":"100%","height":"100%","frameborder":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }